"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
var radio_button_1 = require("@csod/radio-button");
exports.RadioButton = radio_button_1.default;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["RadioButton"] = undefined;


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/8b1685a0cde68c49/src/.tmp/RadioButton/RadioButton.js
// module id = 747
// module chunks = 0